const cartItems = document.querySelectorAll("input.quantity__input");
const cartNote = document.querySelector(".cart__note");

if (cartItems) {
  cartItems.forEach((cartItemInput) => {
    // Ensure Dawn's theme for quantity input field can't be manually updated
    cartItemInput.disabled = true;

    // If certification, show cart note.
    if (cartItemInput.classList.contains('certification') && cartNote) {
      cartNote.classList.remove('hidden');
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  /* let agree = document.querySelector('#agree');
  let checkout = document.querySelector('#checkout');

  agree.addEventListener('click', function(e) {
    if (agree.checked) {
      checkout.disabled = false;
    } else {
      checkout.disabled = true;
    }
  });

  window.addEventListener('SCE:mutate', (event) => {
    console.log(event.detail);
  });

  let shopPayCheckbox = document.querySelector('#shop-pay-checkbox');

  shopPayCheckbox.addEventListener('click', function(e) {
    console.log('here ... no whammy!');
  }); */
});


!function(){if(window&&window.Shopify){const a={add:"SCE:add",update:"SCE:update",change:"SCE:change",clear:"SCE:clear",mutate:"SCE:mutate"},c=["/cart/add","/cart/update","/cart/change","/cart/clear","/cart/add.js","/cart/update.js","/cart/change.js","/cart/clear.js"];if(window.fetch&&"function"==typeof window.fetch){const d=window.fetch;window.fetch=function(){const t=d.apply(this,arguments);return e(arguments[0])&&t.then(e=>{e.clone().json().then(t=>n(e.url,t))}),t}}if(window.XMLHttpRequest){const i=window.XMLHttpRequest.prototype.open;window.XMLHttpRequest.prototype.open=function(){const t=arguments[1];return this.addEventListener("load",function(){e(t)&&n(t,this.response)}),i.apply(this,arguments)}}function e(t){if(t)return t=t.split("/").pop(),c.includes("/cart/"+t)}function n(t,e){if("string"==typeof e)try{e=JSON.parse(e)}catch{}window.dispatchEvent(new CustomEvent(a.mutate,{detail:e}));t=!!(t=t)&&(t.includes("cart/add")?"add":t.includes("cart/update")?"update":t.includes("cart/change")?"change":!!t.includes("cart/clear")&&"clear");switch(t){case"add":window.dispatchEvent(new CustomEvent(a.add,{detail:e}));break;case"update":window.dispatchEvent(new CustomEvent(a.update,{detail:e}));break;case"change":window.dispatchEvent(new CustomEvent(a.change,{detail:e}));break;case"clear":window.dispatchEvent(new CustomEvent(a.clear,{detail:e}))}}}}();
 
/* 
const myCartWatcher = new CartWatcher;
myCartWatcher.init();
window.addEventListener("cart_changed", e => console.log(e.detail));

class CartWatcher {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

 storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

 findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach(oi => {
      const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0
        ? result.added.push(item)
        : result.removed.push(item)
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    const event = new CustomEvent("cart_changed", { detail: changes });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

 observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
} */

/* TESTING */
/* (function () {
  var FREE_GIFT = {
    variantId: 34428528099485,
    threshold: 20000
  };

  // Guards against overlapping checks. Without this, two triggers that
  // fire close together (e.g. two SCE:* events for one user action) can
  // both read the cart before either add.js call lands, and both decide
  // the gift is missing — resulting in it being added twice.
  var isProcessing = false;
  var pendingRecheck = false;

  function cartHasVariant(cart, variantId) {
    return cart.items.some(function (item) {
      return item.variant_id === variantId;
    });
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: FREE_GIFT.variantId, quantity: 1 }]
      })
    });
  }

  function checkCartAndMaybeAddGift() {
    if (isProcessing) {
      // A check is already in flight. Don't start a second one — just
      // remember to run once more after the current one settles, in
      // case the cart changed again while we were waiting.
      pendingRecheck = true;
      return;
    }
    isProcessing = true;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var qualifies = cart.total_price >= FREE_GIFT.threshold;
        var alreadyHasGift = cartHasVariant(cart, FREE_GIFT.variantId);

        if (qualifies && !alreadyHasGift) {
          return addGift()
            .then(function (res) { return res.json(); })
            .then(function () {
              // Let the rest of the site (and the monitor library) know
              // the cart changed, so any cart UI can refresh.
              window.dispatchEvent(new CustomEvent('SCE:mutate', { detail: {} }));
            });
        }
      })
      .catch(function (err) {
        console.error('Free gift check failed:', err);
      })
      .finally(function () {
        isProcessing = false;
        if (pendingRecheck) {
          pendingRecheck = false;
          checkCartAndMaybeAddGift();
        }
      });
  }

  document.addEventListener('DOMContentLoaded', checkCartAndMaybeAddGift);
  window.addEventListener('SCE:add', checkCartAndMaybeAddGift);
  window.addEventListener('SCE:update', checkCartAndMaybeAddGift);
  window.addEventListener('SCE:change', checkCartAndMaybeAddGift);
})(); */